module.exports = __webpack_public_path__ + "img/icon_gongneng8.74fb5666.svg";